var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"60px"}}),_c('b-container',{staticClass:"mt--6",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('ReferenceForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }